/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsListSamples } from "../../funcs/llmEvalsListSamples.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListEvalSamplesRequest$inboundSchema,
};

export const tool$llmEvalsListSamples: ToolDefinition<typeof args> = {
  name: "llm-evals-list-samples",
  description: `List eval samples

Returns prompt, target, model output, extraction, score, and judge details for an eval run.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsListSamples(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
